import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Observable, Subscription } from 'rxjs';
import { DataBaseProvider } from '../../providers/data-base/data-base';
import * as moment from 'moment';
import 'rxjs/add/operator/map'

/**
 * pages shows the admin about the current activites
 * also enables the admin to pull the report and see the activities 
 * of the individual and multiple tenants for the given period of time
 */

@IonicPage()
@Component({
  selector: 'page-activites',
  templateUrl: 'activites.html',
})
export class ActivitesPage {

  allUserData: Observable<any>;
  startDate: string;
  endDate: string;
  logsSubcribtion: any;
  activityRecords: any[];
  summaryRecord: any;
  selectedTenantKey: string;
  recordsSubscription: Subscription;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public $db: DataBaseProvider) {
    this.summaryRecord = {};
  }

  ionViewDidLoad() {
    this.getData();
    this.startDate = moment().format('YYYY-MM-DD');
    this.endDate = moment().format('YYYY-MM-DD');
    // this.startDate = '2019-12-01';
    // this.endDate = '2019-12-02';
    this.getDailyLogs(this.startDate, this.endDate);
  }

  getData() {
    this.allUserData = this.$db.getAllUsers();
  }

  tenantSelectionChange(selectedTenant) {
    this.selectedTenantKey = selectedTenant;
    this.getDailyLogs(this.startDate, this.endDate, selectedTenant);

  }

  startDateChange(event) {
    this.startDate = moment(event, 'YYYY-MM-DD').format('YYYY-MM-DD');
    this.getDailyLogs(this.startDate, this.endDate);
  }

  endDateChange(event) {
    this.endDate = moment(event, 'YYYY-MM-DD').format('YYYY-MM-DD');
    this.getDailyLogs(this.startDate, this.endDate);
  }

  getDailyLogs(startDate, endDate, tenantKey?) {
    tenantKey = tenantKey ? tenantKey : this.selectedTenantKey;
    // adjust the time range for the querry
    this.tryUnsubscribing();
    this.recordsSubscription = this.getRecordSubscription(startDate, endDate).map((records: any[]) => {
      // if no tenants are selected then all tenants are shown
      return (tenantKey ? records.filter(record => record.ownerKey === tenantKey) : records);
    }).subscribe(data => {
      this.populateDataArray(data, startDate, endDate);
      this.populateSummary(data);
    });
  }

  // stops un necessary subscriptions
  tryUnsubscribing() {
    try {
      this.recordsSubscription.unsubscribe();
    } catch (error) { };
  }

  getRecordSubscription(startDate, endDate) {
    return (startDate === endDate) ? this.$db.getActivityLogsForOneDay(startDate) :
      this.$db.getActivityLogs(startDate, endDate);
  }

  populateSummary(records: any[]) {
    this.summaryRecord.numberOfTransactions = 0;
    this.summaryRecord.franchiseeFee = 0;
    this.summaryRecord.serviceCharge = 0;
    records.forEach(record => {
      this.summaryRecord.numberOfTransactions = this.summaryRecord.numberOfTransactions + 1;
      this.summaryRecord.franchiseeFee = this.summaryRecord.franchiseeFee + (isNaN(parseInt(record.franchiseeFee)) ? 0 : parseInt(record.franchiseeFee));
      this.summaryRecord.serviceCharge = this.summaryRecord.serviceCharge + (isNaN(parseInt(record.serviceCharge)) ? 0 : parseInt(record.serviceCharge));
    })
  }
  // the data is classified on the basis of date
  populateDataArray(data: any[], startDate: string, endDate: string) {
    let result = [];
    while (startDate !== endDate) {
      let perDayData = this.getDataForDay(data, startDate);
      perDayData.date = startDate;
      result.push(perDayData);
      startDate = moment(startDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
    }
    // push the data for the last date
    let perDayData = this.getDataForDay(data, startDate);
    perDayData.date = startDate;
    result.push(perDayData);
    this.activityRecords = result;
  }

  // return the seggregated transactions for a date
  getDataForDay(records: any[], date: string) {
    const perDayRecords = records.filter(record => record.date === date);
    return this.sumUpData(perDayRecords);
  }


  // returns the consolidated data 
  sumUpData(records: any[]) {
    let result: any =
    {
      franchiseeFee: 0,
      serviceCharge: 0
    }
    result.numberOfTransactions = 0;
    records.forEach(record => {
      result.franchiseeFee = result.franchiseeFee + (isNaN(parseInt(record.franchiseeFee)) ? 0 : parseInt(record.franchiseeFee));
      result.serviceCharge = result.serviceCharge + (isNaN(parseInt(record.serviceCharge)) ? 0 : parseInt(record.serviceCharge));
      result.numberOfTransactions = result.numberOfTransactions + 1;
    });
    return result;
  }

}




// WEBPACK FOOTER //
// ./src/pages/activites/activites.ts